import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const DoughnutChart = ({ data, compact = false }) => {
    const chartData = {
        labels: ['Total', 'Approved', 'Denied'],
        datasets: [
            {
                data: [
                    data.totalUser || 0,
                    data.approvedUser || 0,
                    data.declinedUser || 0,
                ],
                backgroundColor: ['#E74C3C', '#3498DB', '#C0392B'],
                borderColor: '#FFFFFF',
                borderWidth: 5,
                hoverOffset: 8,
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '72%',
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    color: '#7F8C8D',
                    font: {
                        family: 'Roboto',
                        weight: 500,
                    },
                    padding: 18,
                },
            },
            tooltip: {
                backgroundColor: '#2C3E50',
                padding: 12,
                callbacks: {
                    label: (context) => `${context.label}: ${context.parsed}`
                }
            }
        }
    };

    return (
        <div className={compact ? "flex flex-col items-center gap-6 md:flex-row" : "panel-card relative flex min-h-[330px] flex-col items-center justify-center p-6"}>
            <div className="relative h-[220px] w-full max-w-[320px]">
                <Doughnut data={chartData} options={options} />
            </div>
            <div className={compact ? "flex-1 space-y-4" : "mt-5 w-full max-w-[300px] space-y-3"}>
                {chartData.labels.map((label, index) => (
                    <div key={label} className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <div className="h-3 w-3 rounded-full" style={{ backgroundColor: chartData.datasets[0].backgroundColor[index] }} />
                            <span className="text-sm text-tpColor">{label}</span>
                        </div>
                        <span className="font-semibold text-tColor">{chartData.datasets[0].data[index]}</span>
                    </div>
                ))}
                <div className="rounded-lg bg-lightGrey/70 px-4 py-3">
                    <p className="text-xs font-medium text-tpColor">Gender split</p>
                    <p className="mt-1 text-sm font-semibold text-tColor">
                        {data.totalMale || 0} Grooms / {data.totalFemale || 0} Brides
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DoughnutChart;
